module.exports = __webpack_public_path__ + "img/icon_map_188_off_100.aa468c50.png";